import React, { Suspense } from 'react'
import './App.css';
import './styles/style.css';
import './assets/css/navber.css'
import './assets/css/owl.carousel.min.css'
import './assets/css/responsive.css'
import './assets/css/owl.theme.default.min.css'
import './assets/css/meanmenu.css'
import './assets/css/magnific-popup.min.css'
import './assets/css/animate.min.css';
// import './assets/css/bootstrap.min.css'
import './assets/css/fontawesome.all.min.css'
// import Home from './pages/Home';
import { Route, Routes, HashRouter, Navigate } from 'react-router-dom';
// import Home from './pages/Home';
import routesC from './routes'
import Login from './high_octavez/PagesMenus/Login';
import Login1 from './karuna/PagesMenus/Login';
import Register from './high_octavez/PagesMenus/Register';
import Register1 from './karuna/PagesMenus/Register';
// import Commonlayouts from './common/Commonlayouts';
// import Projects from './pages/Projects';
// import { jQuery} from "jquery";


const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)
const Homemusic = React.lazy(() => import('./high_octavez/Homemusic'))
const Home = React.lazy(() => import('./karuna/Home'))

// const Projects = React.lazy(() => import('./pages/Projects'))
// routes config
const Karunapostermain = React.lazy(() => import('./karuna/karunapostermain'))
// import jQuery from "jquery";

const Commonlayouts = React.lazy(() => import('./common/Commonlayouts'))

const Mail_verify = React.lazy(() => import('./mail_verification/mail_verify'))
const Unsubscribe = React.lazy(() => import('./mail_verification/unsubscribe'))


const EventPayments = React.lazy(() => import('./high_octavez/Eventpayments'))

const Executedonations = React.lazy(() => import('./karuna/PagesMenus/Executedonations'))




function App() {

  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          {/* <Route path="/home" element={<Home />} /> */}

          <Route path="/login" element={<Login1 />} />
          <Route path="/register" element={<Register1 />} />
          <Route path="/karuna" element={<Karunapostermain />} />
          <Route path="/high_octavez/home" element={<Homemusic />} />
          <Route path="/" element={<Navigate replace to="/karuna" />} />
          <Route path="/high_octavez/login" element={<Login />} />
          <Route path="/high_octavez/register" element={<Register />} />
          < Route path="/high_octavez/event_payments" element={<EventPayments />} />
          <Route path="/executedonation" element={<Executedonations/>}/>
          <Route path="*" name="Home" element={<Commonlayouts />} />
          <Route path="/verifymail" name= 'Mail' element= {<Mail_verify />} />
          <Route path='/unsubscribe' name= 'News' element= { <Unsubscribe />} />
        </Routes>
      </Suspense>

    </HashRouter>

  );
}

export default App;
